import { render, staticRenderFns } from "./FormUpdateData.vue?vue&type=template&id=3806f546"
import script from "./FormUpdateData.vue?vue&type=script&lang=js"
export * from "./FormUpdateData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports